// extracted by mini-css-extract-plugin
export default {"advantageItemWrapper":"styles_advantageItemWrapper__ayyHn","titleWrapper":"styles_titleWrapper__oR-EY"};